/**
 * Further reading utilities
 * @class
 */
export default class RichTextComponent {
    constructor(element) {
        this.loadRichText(element);
    }
    /**
     * Load RichText
     */
    loadRichText(parentEl) {
        if (!parentEl) {
            return;
        }
        //console.log('You have a RichText');
        // Get the tables
        const tables = parentEl.querySelectorAll('table');
        if (!tables) {
            return;
        }
        tables.forEach((aTable, index) => {
            if (aTable.parentNode != null) {
                // Create a new div element
                const wrapper = document.createElement('div');
                //console.log("wrapper div for table created");
                // Insert the wrapper before the table in the DOM tree
                aTable.parentNode.insertBefore(wrapper, aTable);
                //console.log("wrapper div for table insreted into the dom");
                // Move table into wrapper
                wrapper.appendChild(aTable);
                //console.log("table appended to the wrapper div");
                //add the style to the wrapper
                wrapper.classList.add("table-is-responsive");
                //console.log("overflow-x auto added to the wrapper div");
                const imagesInTheTable = aTable.querySelectorAll("img");
                if (imagesInTheTable.length != 0) {
                    imagesInTheTable.forEach((anImage) => {
                        var _a;
                        (_a = anImage.closest("td")) === null || _a === void 0 ? void 0 : _a.classList.add("has-an-image");
                    });
                }
            }
        });
    }
    /**
     * Create new instances of RichText for each element with class o-richtextblock"
     */
    static init(scope) {
        [
            ...(scope || document).querySelectorAll('.o-richtextblock'),
        ].forEach((elem) => {
            new RichTextComponent(elem);
        });
    }
}
